<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex lg12">

        <sp-360-panel :title="'management.privileges.manage-privileges' | translate">
          <div data-vv-scope="formPrivileges">
            <div class="row">
              <div class="flex lg12" style="margin-top:56px;">
                <fieldset>
                  <div class="form-group" :class="{ 'has-error': errors.has('formPrivileges.nome') }">
                    <div class="input-group">
                      <!-- management.privileges.name' -->
                      <va-input id="nome" name="nome" required v-model="privilegio.nome" aria-required="true"  v-validate="'required'" label="Nome" />
                    </div>

                  </div>
                  <div class="form-group" :class="{ 'has-error': errors.has('formPrivileges.desc') }">
                    <div class="input-group">
                      <!-- management.privileges.description' -->
                      <va-input id="desc" name="desc" required v-model="privilegio.descricao" aria-required="true" v-validate="'required'" label="Descrição"/>
                    </div>
                  </div>
                  <div class="row">
                    <div class="flex lg6">
                      <va-button type="button" @click="limpar()" class="btn btn-primary btn-sm pull-left">
                        {{'management.clear'| translate}}
                      </va-button>
                    </div>
                    <div class="flex lg6">
                      <va-button type="button" @click="persiste()" class="btn btn-primary btn-sm pull-right">
                        {{'management.save'| translate}}
                      </va-button>
                    </div>
                  </div>
                </fieldset>
              </div>

              <!-- <div class="flex lg4">
                <fieldset>

                </fieldset>
              </div> -->

              <div class="flex lg12">
                  <va-input class="filter-input"
                    v-model="termo"
                    placeholder="Pesquisar"
                    removable
                    @input="pesquisa"
                  >
                    <va-icon name="fa fa-search" slot="prepend" />
                  </va-input>

                  <sp360-dataTable id="tabelaPriv" ref="tabelaPriv"
                    :apiMode="false"
                    :data="dadosPrivFiltrado.data"
                    :fields="tableFields"
                    :dataModeFilterableFields="dataModeFilterableFields"
                    :sortFunctions="sortFunctions"
                    :perPage="itemsPerPage"
                    :filterInputShown="true"
                    @editarRow="editar($event)"
                    @deletarRow="deletarModal($event)"
                  />
              </div>
            </div>

          </div>
        </sp-360-panel>

      </div>
    </div>
    <va-modal ref="privilegioDelModal"
                   :okText="'management.delete' | translate"
                   :cancelText="'management.cancel' | translate"
                   :okClass="'btn btn-primary btn-sm'"
                   :cancelClass="'btn btn-secondary btn-sm'"
                   @ok="deletar()"
                   @cancel="cancelarDelecao()"
                   :title="'management.confirmation' | translate"
                   v-model="openModalDelecao"
                   >
      <template slot="default">
        {{'management.privileges.confirmationText' | translate}}
      </template>
    </va-modal>
  </div>
</template>

<script>
import Vue from 'vue'

import Multiselect from 'vue-multiselect'
import constantes from '@/utils/ConstantesGlobais'
import PrivilegioService from '@/services/PrivilegioService'
import MetodosGlobais from '@/utils/MetodosGlobais'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'

export default {
  components: { Multiselect, 'sp360-dataTable': Sp360DataTable, Sp360Panel },
  name: 'privilegio',
  computed: {

  },
  data () {
    return {
      termo: null,
      openModalDelecao: false,
      privilegio: PrivilegioService.newPrivilegio(),
      options: {
        perfis: [],
        unidades: [],
      },
        dadosPriv: {
          'data': [],
        },
        dadosPrivFiltrado: {
          'data': [],
        },
      itemsPerPage: constantes.TAMANHO_TABELAS,
      tableFields: [
        {
          name: 'id',
          sortField: 'id',
          title: this.$t('management.privileges.id'),
          width: '5%',
        },
        {
          name: 'nome',
          sortField: 'nome',
          title: this.$t('management.privileges.name'),
        },
        {
          name: 'descricao',
          sortField: 'descricao',
          title: this.$t('management.privileges.description'),
        },
        {
          name: '__slot:edicao',
          dataClass: 'action-slot',
        },
        {
          name: '__slot:delecao',
          dataClass: 'action-slot',
        },
      ],
      dataModeFilterableFields: ['nome'],
      sortFunctions: {
        'id': MetodosGlobais.ordenaTabela,
        'nome': MetodosGlobais.ordenaTabela,
        'descricao': MetodosGlobais.ordenaTabela,
      },
    }
  },
  beforeCreate () {
    this.$store.dispatch('privilegio/getAllPrivilegio').then(
      retorno => {
        this.dadosPriv.data = retorno.data
        this.dadosPrivFiltrado.data = retorno.data
        this.updateTabelaPriv(this.dadosPrivFiltrado)
        // this.$refs.tabelaPriv.update()
      }
    )
  },
  methods: {
    pesquisa: _.debounce(function (term) {
      this.termo = term
      let a = []

      if((!Number.isNaN(parseInt(term))) && term !="" ){
        a = this.$refs.tabelaPriv.filterByNumber(this.dadosPriv.data, this.termo)
      }else{
        a = this.$refs.tabelaPriv.filterByString(this.dadosPriv.data, this.termo)
      }
      
      this.dadosPrivFiltrado.data = a
      this.updateTabelaPriv(this.dadosPrivFiltrado)
    }, 400),
    
    showSmallModal () {
      this.$refs.smallModal.open()
    },
    valida () {
      return this.$validator.validateAll('formPrivileges').then(valid => {
        return valid
      })
    },
    persiste () {
      event.preventDefault()
      this.valida().then(valido => {
        if (!valido) {
          this.showToast(this.$t('management.incorrectFields'), constantes.TOASTED_ERROR)
        } else {
          if (this.privilegio.id == 0) {
            this.$store.dispatch('privilegio/postPrivilegioRetornar', this.privilegio)
              .then(retorno => {
                this.showToast(this.$t('management.privileges.privilege') + ` ${retorno.data.nome}` + this.$t('management.inserted'), constantes.TOASTED_SUCCESS)
                this.dadosPriv.data.push(retorno.data)
                this.limpar()
                // this.$refs.tabelaPriv.update()
              })
              .catch(err => {
                console.error(err)
                this.showToast(this.$t('management.insertedError'), constantes.TOASTED_ERROR)
              })
          } else {
            let index = _.findIndex(this.dadosPriv.data, priv => priv.id == this.privilegio.id)

            this.$store.dispatch('privilegio/putPrivilegio', this.privilegio).then(
              retorno => {
                this.updatePrivilegio(this.privilegio, index)
                this.showToast(this.$t('management.privileges.privilege') + ` ${this.privilegio.nome}` + this.$t('management.updated'), constantes.TOASTED_SUCCESS)
                this.limpar()
              })
              .catch(err => {
                console.error(err)
                this.showToast(this.$t('management.updatedError'), constantes.TOASTED_ERROR)
              })
          }
        }
      })
    },
    updatePrivilegio (privilegio, index) {
      Vue.set(this.dadosPriv.data, index, privilegio)
      // this.$refs.tabelaPriv.update()
      this.$refs.tabelaPriv.resetPage()
    },
    editar (event) {
      this.privilegio = _.cloneDeep(event.rowData)
    },
    deletarModal (event) {
      this.privilegioADeletar = event.rowData
      this.openModalDelecao = true
    },
    deletar () {
      this.$store.dispatch('privilegio/deletePrivilegio', this.privilegioADeletar.id).then(
        retorno => {
          this.showToast(this.$t('management.privileges.privilege') + ` ${this.privilegioADeletar.nome}` + this.$t('management.deleted'), constantes.TOASTED_SUCCESS)
          this.dadosPriv.data = this.dadosPriv.data.filter(priv => {
            return priv.id != this.privilegioADeletar.id
          })
          // this.$refs.tabelaPriv.update()
        }
      )
        .catch(err => {
          console.error(err)
          this.showToast(this.$t('management.deletedError'), constantes.TOASTED_ERROR)
        })
    },
    cancelarDelecao () {
      this.privilegioADeletar = {}
    },
    limpar () {
      event.preventDefault()
      this.privilegio = PrivilegioService.newPrivilegio()
      this.$validator.reset()
    },
    updateTabelaPriv(dados){
      this.$set(this.dadosPrivFiltrado, 'data', dados.data)
    },
  },
  created () {
    // this.options.perfis = ['ADMIN', 'PREFEITO', 'MANAGER', 'SECRETARIO'];
    this.options.perfis = [{ id: 1, desc: 'ADMIN' }, { id: 2, desc: 'PREFEITO' }, { id: 3, desc: 'MANAGER' }, { id: 4, desc: 'SECRETARIO' }]
  },
}
</script>

<style lang="scss">
  @import "../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css";
  .multiselect__placeholder {
    color: $brand-success;
  }
</style>
